import React, { FC } from 'react'

import { VerifiedIconWrapper } from 'components/presentational/title/VerifiedIconWrapper'
import { GQLGender } from 'generated-graphql/graphql'

export const ProfileVerification: FC<{
  name: string
  iconUid: string
  statusVerification?: boolean
  gender?: GQLGender
}> = ({ name, iconUid, statusVerification, gender }) => {
  if (statusVerification) {
    return <VerifiedIconWrapper iconUid={iconUid} name={name} gender={gender} />
  }

  return null
}
